import React from "react";
import { AppContextModel } from '../models/context/App-Context-Model';

const AppContextModelDefault = new AppContextModel();

export const AppContext = React.createContext<AppContextModel>(AppContextModelDefault);
